import { useEffect, useState } from "react";
import { MagnifyingGlassIcon, PlusIcon } from "@heroicons/react/24/outline";
import { getPermissions } from "../../../db/PermissionsApi";
import PermissionsList from "./PermissionsList";
import PermissionModal from "./PermissionModal";
import DeletePermissionModal from "./DeletePermissionModal";
import { useAuth } from "../../../contexts/AuthContext";

export default function PermissionManagementPage() {
  const { currentUser } = useAuth();
  const userId = currentUser?.id;
  const [permissions, setPermissions] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPermission, setSelectedPermission] = useState(null);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [permissionToDelete, setPermissionToDelete] = useState(null);

  const loadPermissions = async () => {
    setLoading(true);
    const data = await getPermissions(userId, search);
    setPermissions(Array.isArray(data) ? data : []);
    setLoading(false);
  };

  useEffect(() => {
    loadPermissions();
  }, [search]);

  const handleAdd = () => {
    setSelectedPermission(null);
    setIsModalOpen(true);
  };

  const handleEdit = (perm) => {
    setSelectedPermission(perm);
    setIsModalOpen(true);
  };

  const handleDeleteRequest = (perm) => {
    setPermissionToDelete(perm);
    setDeleteModalOpen(true);
  };

  return (
    <div className="p-6 space-y-6 text-primary">
      <h1 className="text-2xl font-bold">Gestion des permissions</h1>

      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="w-full md:w-64 relative">
          <MagnifyingGlassIcon className="w-5 h-5 absolute left-3 top-3 text-gray-400" />
          <input
            type="text"
            placeholder="Rechercher…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="input input-bordered w-full pl-10"
          />
        </div>

        <button
          onClick={handleAdd}
          className="btn bg-primary text-white rounded-full flex items-center gap-2"
        >
          <PlusIcon className="w-5 h-5" />
          Ajouter
        </button>
      </div>

      <PermissionsList
        permissions={permissions}
        loading={loading}
        onEdit={handleEdit}
        onDelete={handleDeleteRequest}
        userId={userId}
      />

      {/* MODAL: Add / Edit */}
      {isModalOpen && (
        <PermissionModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSave={loadPermissions}
          permissionItem={selectedPermission}
          userId={userId}
        />
      )}

      {/* MODAL: Delete */}
      {deleteModalOpen && (
        <DeletePermissionModal
          isOpen={deleteModalOpen}
          onClose={() => setDeleteModalOpen(false)}
          permission={permissionToDelete}
          onDeleted={loadPermissions}
          userId={userId}
        />
      )}
    </div>
  );
}
